













import _ from 'lodash';
import { notify, HasTaskMixin } from 'mycorems-app-shared';
import eventBus from '../../messaging/event-bus';
import { SubscribedToAccount, UnsubscribedFromAccount } from '../../messaging/events';
import {
  Account, AccountSubscriber, AccountSubscriberFilters, QueryResult,
} from '../../types';
import recognition from '../../auth/recognition';
import { subscribe, unsubscribe } from './index';
import AccountType from '../AccountType';
import repository from './client-subscriber-repository';
import accountRepository from '../account-repository';

interface Data {
  account: Account|null,
  accountSubscriber: AccountSubscriber|null,
}

export default HasTaskMixin.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      account: null,
      accountSubscriber: null,
    };
  },
  watch: {
    accountId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  computed: {
    userId(): string|null {
      return recognition.getUserId();
    },
    isClient(): boolean {
      if (!this.account) return false;
      return AccountType.isClient(this.account.type);
    },
    isSubscribed(): boolean {
      return !_.isNil(this.accountSubscriber);
    },
    iconClass(): string {
      return (this.isSubscribed) ? 'far fa-bell-slash' : 'far fa-bell';
    },
    text(): string {
      return (this.isSubscribed) ? 'Unsubscribe' : 'Subscribe';
    },
    title(): string {
      if (this.isSubscribed) {
        if (!this.accountSubscriber) return '';
        return `You are subscribed to ${this.accountSubscriber.account.name}`;
      }
      return 'Click to subscribe';
    },
    filters(): AccountSubscriberFilters {
      return {
        accountId: this.accountId,
        userId: (this.userId !== null) ? this.userId : undefined,
      };
    },
  },
  methods: {
    load(): void {
      this.task = accountRepository.find(this.accountId);
      this.task.then((account: Account) => {
        this.account = account;
        this.checkIfSubscribed();
      });
    },
    checkIfSubscribed(): void {
      this.accountSubscriber = null;
      repository
        .findSubscribers(this.filters)
        .then((result: QueryResult) => {
          // eslint-disable-next-line prefer-destructuring
          this.accountSubscriber = (result.items as AccountSubscriber[])[0];
        });
    },
    toggle(): void {
      if (this.isSubscribed) {
        this.unsubscribe();
      } else {
        this.subscribe();
      }
    },
    subscribe(): void {
      if (!this.userId) return;
      this.task = subscribe(this.accountId, this.userId);
      this.task.then((accountSubscriber: AccountSubscriber) => {
        this.accountSubscriber = accountSubscriber;
        this.$emit('subscribed', accountSubscriber);
        notify.success(`Subscribed to ${accountSubscriber.account.name}.`);
      });
    },
    unsubscribe(): void {
      if (!this.accountSubscriber) return;
      this.task = unsubscribe(this.accountSubscriber.id);
      this.task.then(() => {
        this.$emit('unsubscribed', this.accountSubscriber);
        notify.success(
          `Unsubscribed from
           ${(this.accountSubscriber) ? this.accountSubscriber.account.name : ''}.`,
        );
        this.accountSubscriber = null;
      });
    },
  },
  created(): void {
    this.load();
    eventBus.$on(SubscribedToAccount.eventName, this.load);
    eventBus.$on(UnsubscribedFromAccount.eventName, this.load);
  },
  beforeDestroy(): void {
    eventBus.$off(SubscribedToAccount.eventName, this.load);
    eventBus.$off(UnsubscribedFromAccount.eventName, this.load);
  },
});
